import { render, staticRenderFns } from "./StockPurchaseReportAllReport.vue?vue&type=template&id=18041a75&"
import script from "./StockPurchaseReportAllReport.vue?vue&type=script&lang=js&"
export * from "./StockPurchaseReportAllReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports